import Layout from '@/layouts'
import {i18n} from "@/utils/i18n";

const specialty = {
  path: '/citizenship',
  component: Layout,
  name: 'citizenship',
  redirect: '/citizenship/index',
  children: [{
    path: '/citizenship/index',
    component: () => import('@/views/citizenship/index'),
    name: 'citizenship.index',
    meta: {
      title: i18n.t(`message.citizenship`)
    }
  }, ]
}

export default specialty